import React, { useContext, useEffect, useState } from "react";
import { useForm, useStep } from "react-hooks-helper";
import { useRef } from "react";

import { store } from "../../store";
import { Text } from "mondrian-react";

import Loading from "components/Loading";
import Analytics from "core/Utils/Analytics";
import LoginNumbersApi from "core/api/loginNumbers/LoginNumbersApi";
import AlterarNumero from "./AlterarNumero";
import AdicionarNumero from "./AdicionarNumero";
import ExcluirNumero from "./ExcluirNumero";
import Legend from "components/Legend";
import Fieldset from "components/Fieldset";
import MainTitle from "components/MainTitle";
import FormContainer from "components/FormContainer";
import Button from "components/Button";
import InputControl from "components/InputControl";
import Input, { Select } from "components/Input";
import Modal from "components/Modal";

const defaultData = {};

const GerenciarNumeros = ({ images }) => {
  const steps = [
    { id: null },
    { id: "info" },
    { id: "adicionar" },
    { id: "alterar" },
    { id: "excluir" },
  ];
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const [formData, setForm] = useForm(defaultData);
  const { step, navigation } = useStep({ initialStep: 0, steps });
  const { id } = step;
  const [isLoading, setIsLoading] = useState(false);
  const [loginNumbersArr, setLoginNumbersArr] = useState([]);
  const [error, setError] = useState(null);
  const [inputMsisdnValid, setInputMsisdnValid] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const props = { navigation, setIsLoading, setError, setModalContent };
  function onRequestClose(data = {}) {
    setModalContent(null);
  }
  const { accesstoken } = state;
  useEffect(
    function () {
      if (accesstoken) {
        getLoginNumbers(accesstoken);
      }
    },
    [accesstoken]
  );
  useEffect(function () {
    dispatch({
      type: "SET_GA",
      payload: { currentFlow: "acesso-pelo-celular" },
    });
    Analytics().setVirtualPageView(`/meuperfil/acesso-pelo-celular`);
  }, []);

  async function getLoginNumbers(accesstoken) {
    setIsLoading(true);
    let result = await LoginNumbersApi(accesstoken);
    let { error = null, userDataJwe: userData, loginNumbers = [] } = result;
    if (error != null) {
      const { message, originalMessage = message } = error.warning;
      setModalContent(error);
      Analytics().setErrorEvent({
        eventAction: "callback:meus-numeros",
        eventLabel: originalMessage,
        code: error?.errorCode
      });
      setIsLoading(false);

      return null;
    }
    setLoginNumbersArr(loginNumbers);
    if (loginNumbers.length === 1) {
      let loginNumberValue = loginNumbers[0].id;
      let loginNumberText = loginNumbers[0].msisdn;
      dispatch({
        type: "SET_USER_DATA",
        payload: {
          selectedMsisdn: loginNumberValue,
          selectedMsisdnText: loginNumberText,
        },
      });
      setInputMsisdnValid(true);
    }
    dispatch({
      type: "SET_USER_DATA",
      payload: { userData: userData },
    });
    navigation.go("info");

    setIsLoading(false);
  }
  function handleChange(event) {
    const { value } = event.target;
    var index = event.nativeEvent.target.selectedIndex;
    let text = event.nativeEvent.target[index].text;
    if (!value) {
      setInputMsisdnValid(false);
      setError("Selecione uma opção");
    } else {
      setInputMsisdnValid(true);
      dispatch({
        type: "SET_USER_DATA",
        payload: { selectedMsisdn: value, selectedMsisdnText: text },
      });
      setError("");
    }
  }

  function handleAdd(e) {
    e.preventDefault();
    dispatch({
      type: "SET_USER_DATA",
      payload: { selectedMsisdn: inputMsisdnValid },
    });
    navigation.go("adicionar");
  }

  function handleUpdate(e) {
    e.preventDefault();
    navigation.go("alterar");
  }

  function handleDelete(e) {
    e.preventDefault();
    navigation.go("excluir");
  }

  // const utilizeFocus = () => {
  //   const ref = React.createRef();
  //   const setFocus = () => {
  //     ref.current && ref.current.focus();
  //   };

  //   return { setFocus, ref };
  // };

  const hasLoginNumbers = loginNumbersArr && loginNumbersArr.length;

  const Info = (
    <div id="formDiv">
      <FormContainer>
        <MainTitle sm tabIndex="20" data-testid="acesso-pelo-celular">
          Acesso pelo celular
        </MainTitle>
        <Legend>
          {hasLoginNumbers ? (
            <>
              <Text>
                Confira no campo abaixo os números ativos para realizar o login
                utilizando apenas o seu celular.
              </Text>
              <Text>
                Aqui você pode desativar e alterar os números ativos para fazer
                o seu acesso e aproveitar os benefícios da Claro.
              </Text>
            </>
          ) : (
            <Text>
              No momento você não possui um número de celular ativado para
              realizar o seu login.
            </Text>
          )}
        </Legend>
        <Fieldset>
          {hasLoginNumbers ? (
            <InputControl>
              <Select
                tabIndex="21"
                name="msisdn"
                disabled={loginNumbersArr.length === 1}
                disableDefaultOption={loginNumbersArr.length === 1}
                onChange={(e) => handleChange(e)}
                label="Celular"
              >
                {loginNumbersArr?.map((el) => (
                  <option value={el.id} selected={loginNumbersArr.length === 1}>
                    {el.msisdn}
                  </option>
                ))}
              </Select>
            </InputControl>
          ) : null}
          <div className="mp-button-group">
            {!hasLoginNumbers ? (
              <Button role='button' type="button" onClick={(e) => handleAdd(e)} tabIndex="16">
                Adicionar
              </Button>
            ) : null}
            {hasLoginNumbers ? (
              <>
                <Button
                  type="button"
                  onClick={(e) => handleDelete(e)}
                  disabled={!inputMsisdnValid}
                  secondary
                  tabIndex="22"
                >
                  Desativar
                </Button>
                <Button
                  tabIndex="23"
                  type="button"
                  onClick={(e) => handleUpdate(e)}
                  disabled={!inputMsisdnValid}
                >
                  Alterar
                </Button>
              </>
            ) : null}
          </div>
        </Fieldset>
      </FormContainer>
    </div>
  );
  let CurrentPage = null;
  switch (id) {
    case "adicionar":
      CurrentPage = <AdicionarNumero {...props} />;
      break;
    case "alterar":
      CurrentPage = <AlterarNumero {...props} />;
      break;
    case "excluir":
      CurrentPage = <ExcluirNumero {...props} />;
      break;
    case "info":
      CurrentPage = Info;
      break;
    default:
      CurrentPage = null;
  }
  return (
    <>
      {modalContent && (
        <Modal onClose={onRequestClose} content={modalContent} />
      )}
      <Loading isLoading={isLoading} />
      {CurrentPage}
    </>
  );
};

export default GerenciarNumeros;
